import { render, staticRenderFns } from "./delivery-type-form.vue?vue&type=template&id=6270d6f3&"
import script from "./delivery-type-form.vue?vue&type=script&lang=js&"
export * from "./delivery-type-form.vue?vue&type=script&lang=js&"
import style0 from "./delivery-type-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports